import RouterViewBody from '~/views/RouterViewBody.vue'
export default [
  {
    path: 'documents',
    component: () => import('~/views/template/ViewsTemplateMain.vue'),
    meta: {
      breadCrumbLocalStorage: 'translations',
      breadCrumb: (translation) => translation.pages.setting.pages['free_documents'],
    },
    props: { type: 'documents' },
    name: 'documents',
    redirect: {
      name: 'documentsPersonal',
    },
    children: [
      {
        path: 'personal',
        redirect: {
          name: 'documentsPersonal',
        },
        component: RouterViewBody,
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages['setting-free_documents'].pages.personal,
        },
        children: [
          {
            path: '',
            name: 'documentsPersonal',
            component: () => import('~/views/documents/documents.vue'),
            meta: {
              search: true,
              responsive: true,
              requestType: 'online',
            },
          },
          {
            path: ':id',
            name: 'documentsPersonalShow',
            component: () => import('~/views/documents/documentsShow.vue'),
            meta: {
              breadCrumbGetter: 'freeDocumentsGroups/freeDocumentsGroupsShow',
              breadCrumb: (group) => group.name,
              paginations: {
                page: 1,
                limit: 10,
              },
              responsive: true,
              requestType: 'online',
            },
          },
        ],
      },
      {
        path: 'all',
        redirect: {
          name: 'documentsAll',
        },
        component: RouterViewBody,
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages['setting-free_documents'].pages.all,
          access: { abilities: ['view_free_documents'] },
        },
        children: [
          {
            path: '',
            name: 'documentsAll',
            component: () => import('~/views/documents/documents.vue'),
            meta: {
              search: true,
              paginations: {
                page: 1,
                limit: 10,
              },
              responsive: true,
              requestType: 'admin',
            },
          },
          {
            path: ':id',
            name: 'documentsAllShow',
            component: () => import('~/views/documents/documentsShow.vue'),
            meta: {
              breadCrumbGetter: 'freeDocumentsGroups/freeDocumentsGroupsShow',
              breadCrumb: (group) => group.name,
              paginations: {
                page: 1,
                limit: 10,
              },
              responsive: true,
              requestType: 'admin',
            },
          },
        ],
      },
    ],
  },
]
